<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="verify-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3">Verify</h3>
      <VerifyForm />
    </div>
  </b-container>
</template>

<script>
import VerifyForm from '../../components/Forms/VerifyForm'

export default {
  name: 'Verify',
  components: { VerifyForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/Verify.vue?29a08747